import { getColor } from '@volt_developers/foundations';

const TAG_COLORS = {
    background: {
        default: getColor("blue50"),
        error: getColor("red50"),
        inactive: getColor("white"),
    },
    body: {
        default: getColor("blue500"),
        error: getColor("red500"),
        inactive: getColor("steel400"),
    },
    border: {
        default: getColor("blue100"),
        inactive: getColor("navy50"),
        error: getColor("red100"),
    },
};
const INPUT_TAG_COLORS = {
    background: {
        default: getColor("navy25"),
        hover: getColor("navy50"),
        pressed: getColor("navy100"),
    },
    body: {
        default: getColor("steel400"),
    },
};

export { INPUT_TAG_COLORS, TAG_COLORS };
//# sourceMappingURL=styles.js.map
